import { getOrderDetails } from "../../state_management/epics";

export const directResolve = async (details: {
  orderId: string | undefined | null;
  direct: string | undefined | null;
  token: string | undefined | null;
}) => {
  const { direct, orderId, token } = details;
  if (!orderId && !direct && !token) {
    return;
  } else if (!orderId || !direct || direct !== "true" || !token) {
    throw new Error("Incompete details");
  } else {
    return await getOrderDetails({ orderId, token });
  }
};
